import { render, staticRenderFns } from "./instructionsDetailShopItemPrint.vue?vue&type=template&id=38af9821&scoped=true&"
import script from "./instructionsDetailShopItemPrint.vue?vue&type=script&lang=js&"
export * from "./instructionsDetailShopItemPrint.vue?vue&type=script&lang=js&"
import style0 from "./instructionsDetailShopItemPrint.vue?vue&type=style&index=0&id=38af9821&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38af9821",
  null
  
)

export default component.exports